// 禾康线上
//   const baseURL = 'http://zhyj.hk952183.com/api'
//          const baseURL = 'http://192.168.31.164:3338/api'
//                 const baseURL = 'http://112.25.186.214:3338/api' //石
//                 const baseURL = 'https://zhyj.hk952183.com/api' //石
//                                 const baseURL = 'http://192.168.31.15:3338/api'//郭
//
//      const baseURL = 'http://192.168.31.188:3338/api'
//      const baseURL = 'http://106.75.237.18:8080/api';//测试库
//                                         const baseURL = 'https://zhyl.hk952183.com/api' //测试库
//      const baseURL = 'http://192.168.111.45:3338/api'  //时
//                                const baseURL = 'http://113.31.113.12:8080/api'
//                      const baseURL = 'http://192.168.31.170:3338/api'   //田
//      const baseURL = 'http://36.111.188.123:3338/api'   //毕节/
//                         const baseURL = 'http://zhyj.hk952183.com/api'
                   const baseURL = 'https://zhyj.hk952183.com/api'
//
//
export const uploadVote = baseURL + '/ypt/controller/uploadVotePic/info/uploadPartyVote'
//上传图片地址
export const uploadImg = baseURL + '/ypt/controller/uploadVotePic/info/uploadPartyPhoto'
// 上传图片地址
// export const uploadFilesBaseUrl = 'http://192.168.1.57:8066/api'
 export const uploadFilesBaseUrl = 'http://zhyj.hk952183.com/api'
// export const uploadFilesBaseUrl = 'https://zhyj.hk952183.com/api'
//上传附件地址

// 组织活动上传视频和上传附件
// export const uploadVote1 = 'http://192.168.1.57:8066/api' + '/controller/uploadVotePic/info/uploadOrgLife'
// export const uploadVote2 = 'http://192.168.1.57:8066/api' + '/admin/consul/info/uplodfiles'

export const uploadVote1 = 'https://zhyj.hk952183.com/api' + '/controller/uploadVotePic/info/uploadOrgLife'
export const uploadVote2 = 'https://zhyj.hk952183.com/api' + '/admin/consul/info/uplodfiles'
// export const uploadVote1 = 'http://zhyl.hk952183.com/api' + '/controller/uploadVotePic/info/uploadOrgLife'
// export const uploadVote2 = 'http://zhyl.hk952183.com/api' + '/admin/consul/info/uplodfiles'
export default baseURL
